import { TServerError } from "@/types/api/shared";

interface ApiErrorOptions extends ErrorOptions {
  status?: number;
}

class ApiError extends Error {
  status: number;
  constructor(message: string, options?: ApiErrorOptions) {
    super(message, { cause: options?.cause });
    this.status = options?.status;
  }
}

export async function getApiError(response: Response): Promise<TServerError> {
  const body = await response.json();

  const message =
    response?.status === 429
      ? "too_many_request_error"
      : body?.msg || "server_error";

  return new ApiError(message, {
    status: body?.status,
  });
}
